import { useAppSelector } from '../../../../../../store/hooks'
import CallToActions from '../../../../../common/forms/fields/CallToActions'
import { FC, useEffect, useState } from 'react'
import { BuilderPageHeaderProps } from '../../PageBuilder.d'
import RenderTranslatedFields from '../../../../../common/forms/fields/translated-fields/RenderTranslatedFields'
import { hexToRgb } from '../../utils/helper'

const PageHeader: FC<BuilderPageHeaderProps> = ({
    data,
    formikProps,
    availablePages,
    deletedCtas,
    setDeletedCtas,
    headerSizeCodes,
    previewTheme,
}) => {
    const { theme } = useAppSelector((state) => state.theme)

    const { image_url: mainHeaderImgSrc, translations } = data.pagePart

    const [headerHeight, setHeaderHeight] = useState<string>('20rem')

    useEffect(() => {
        const hSize = headerSizeCodes[formikProps.values.header_size_id] || 'H'
        switch (hSize) {
            case 'Q':
                setHeaderHeight('20rem')
                break
            case 'H':
                setHeaderHeight('30rem')
                break
            default:
                setHeaderHeight('50rem')
                break
        }
    }, [formikProps.values.header_size_id, headerSizeCodes])

    return (
        <header
            className={`masthead`}
            style={{
                height: headerHeight,
                background: mainHeaderImgSrc
                    ? `linear-gradient(to bottom, rgba(${hexToRgb(
                          previewTheme?.colors.secondary.hex
                      )}, 0.5) 20%, ${
                          theme === 'dark'
                              ? 'rgba(0, 0, 0, 0.2)'
                              : `rgba(${hexToRgb(
                                    previewTheme?.colors.primary.hex
                                )}, 0.75)`
                      } 100%), url(${mainHeaderImgSrc})`
                    : `linear-gradient(to bottom, rgba(${hexToRgb(
                          previewTheme?.colors.secondary.hex
                      )}, 1) 20%, ${
                          theme === 'dark'
                              ? 'rgba(0, 0, 0, 0.2)'
                              : `rgba(${hexToRgb(
                                    previewTheme?.colors.primary.hex
                                )}, 1)`
                      } 100%)`,
            }}
        >
            <div className={`container px-4 px-lg-5 page-builder-header`}>
                <div
                    className={`row gx-4 gx-lg-5 align-items-center justify-content-center text-center`}
                >
                    <RenderTranslatedFields
                        id="pageHeadersTranslatedField"
                        tabGroupClassName="bg-transparent"
                        tabContentClassName="bg-transparent"
                        formikProps={formikProps}
                        fields={[
                            {
                                id: 'pageHeadersMainHeaderTop',
                                type: 'text',
                                name: 'main_header_top',
                                // label: 'Main Header Top',
                                className:
                                    'text-center h1 bg-transparent text-white',
                                placeholder: 'Enter main header top',
                            },
                            {
                                id: 'pageHeadersMainHeaderMiddleBig',
                                type: 'text',
                                name: 'main_header_middle_big',
                                // label: 'Main Header Middle (Big)',
                                className:
                                    'text-center h3 bg-transparent text-white',
                                placeholder: 'Enter main header middle (big)',
                            },
                            {
                                id: 'pageHeadersMainHeaderBottom',
                                type: 'text',
                                name: 'main_header_bottom',
                                // label: 'Main Header Bottom',
                                className:
                                    'text-center p bg-transparent text-white',
                                placeholder: 'Enter main header bottom',
                            },
                        ]}
                    />

                    <div className="col-lg-8 align-self-baseline">
                        <CallToActions
                            formikProps={formikProps}
                            translations={translations}
                            availablePages={availablePages}
                            deletedCtas={deletedCtas}
                            setDeletedCtas={setDeletedCtas}
                        />
                    </div>
                </div>
            </div>
        </header>
    )
}

export default PageHeader
